export default "__VITE_ASSET__Dg7jIn07__"